import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { UiService } from '../../services/api.services';

@Component({
  selector: 'app-portal-modal',
  templateUrl: './portal-modal.component.html',
  styleUrls: ['./portal-modal.component.scss'],
})
export class PortalModalComponent implements OnInit, OnDestroy {

  @Input() bodycolor: string;
  @Input() title: string;
  @Input() showBackButton: string;
  @Input() header: string;
  showBackButtonBoolean = true;
  showHeader = false;

  private loginRedirectSubscription: Subscription;

  constructor(private modalController: ModalController, private uiService: UiService) { }

  ngOnInit() {
    this.loginRedirectSubscription = this.uiService.subscribeToLoginRedirectEvent( () => {
      this.dismiss();
    });
    if (this.showBackButton && this.showBackButton.toLowerCase() === 'false') {
      this.showBackButtonBoolean = false;
    }
    if (this.header && this.header.toLowerCase() === 'true') {
      this.showHeader = true;
    }
  }

  ngOnDestroy() {
    if (this.loginRedirectSubscription) {
      this.loginRedirectSubscription.unsubscribe();
    }
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true
    });
  }

}
